// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"263":"7fe88e6a","540":"21af92dd"}[chunkId] + ".css";
};